import React from "react";
import styled, { css, useTheme } from "styled-components";
import Tooltip from "components/common/Tooltip";
const PERCENTAGE_SPACING_THRESHOLD = 20;
const VisualisationWrapper = styled.div(
  ({ theme }) => css`
    padding-left: ${theme.spacings.md};
    padding-right: ${theme.spacings.md};
    display: flex;
    align-items: center;
    justify-content: space-between;
  `
);
const BarWrapper = styled.div`
  overflow: hidden;
  width: 100%;
`;
const MaxDaysLabel = styled.p(
  ({ theme }) => css`
    margin-left: ${theme.spacings.sm};
    margin-bottom: 0;
  `
);
const AnnotationBar = styled.div`
  position: relative;
  height: 60px;
`;
const LifeCycleBar = styled.div(
  ({ theme }) => css`
    height: 40px;
    background: ${theme.colors.variant.lighter.info};
    position: relative;
  `
);
const Bar = styled.div(
  ({ theme, value, color }) => css`
    height: 100%;
    font-size: ${theme.fonts.size.small};
    text-align: center;
    flex-shrink: 0;
    background-color: ${color};
    transition: width 500ms ease-in-out;
    position: absolute;
    left: 0;
    width: ${value}%;
    max-width: 100%;
    cursor: pointer;

    &::after {
      border-right: 1px solid ${theme.colors.variant.darkest.info};
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      height: 60px;
      z-index: 1;
    }
  `
);
const Label = styled.div(
  ({ value }) => css`
    position: absolute;
    bottom: 25px;
    ${value > 3 ? `right: ${100 - value}%;` : "left: 0;"}
  `
);
const DataTieringVisualisation = ({
  archiveData = false,
  minDays = 0,
  maxDays = 0,
  minDaysInHot = 0,
  warmTierEnabled = false
}) => {
  const theme = useTheme();
  const percentageFor = (days) => {
    if (days <= 0 || maxDays <= 0) return 0;
    return days / maxDays * 100;
  };
  const minDaysPercentage = percentageFor(minDays);
  const minDaysInHotPercentage = percentageFor(minDaysInHot);
  const showHotTier = warmTierEnabled && minDaysInHotPercentage > 0;
  return /* @__PURE__ */ React.createElement(VisualisationWrapper, null, /* @__PURE__ */ React.createElement(BarWrapper, null, /* @__PURE__ */ React.createElement(AnnotationBar, null, minDaysPercentage > 0 && /* @__PURE__ */ React.createElement(Label, { value: minDaysPercentage }, minDays, " days"), showHotTier && minDaysInHotPercentage !== minDaysPercentage && /* @__PURE__ */ React.createElement(Label, { value: minDaysInHotPercentage }, minDaysInHot, " days")), /* @__PURE__ */ React.createElement(LifeCycleBar, null, /* @__PURE__ */ React.createElement(
    Tooltip,
    {
      label: "Min. # of days in storage",
      position: minDaysPercentage <= PERCENTAGE_SPACING_THRESHOLD ? "bottom-start" : "bottom-end",
      withArrow: true
    },
    /* @__PURE__ */ React.createElement(Bar, { value: minDaysPercentage, color: theme.colors.variant.info })
  ), showHotTier && /* @__PURE__ */ React.createElement(
    Tooltip,
    {
      label: minDaysInHotPercentage === minDaysPercentage ? "Min. # of days in Hot Tier and storage" : "Min. # of days in Hot Tier",
      position: minDaysInHotPercentage <= PERCENTAGE_SPACING_THRESHOLD ? "bottom-start" : "bottom-end",
      withArrow: true
    },
    /* @__PURE__ */ React.createElement(Bar, { value: minDaysInHotPercentage, color: theme.colors.variant.darkest.info })
  ))), /* @__PURE__ */ React.createElement(MaxDaysLabel, null, archiveData ? "Archived and deleted" : "Deleted", " after ", /* @__PURE__ */ React.createElement("strong", null, maxDays, " days")));
};
export default DataTieringVisualisation;
